interface PrintAreaLinesState {
  anyElementSelected: boolean;
  isEmpty: boolean;
  hasBackgroundImage: boolean;
  showPrintAreaLines: boolean;
  hasSpreadMask: boolean;
}

/**
 * The print-area lines are a rectangle around the content area. A masked
 * spread's printable region is the mask silhouette, not that rectangle, so
 * drawing it there frames the shape in a box that means nothing.
 */
function shouldShowPrintAreaLines({
  anyElementSelected,
  isEmpty,
  hasBackgroundImage,
  showPrintAreaLines,
  hasSpreadMask,
}: PrintAreaLinesState): boolean {
  return (anyElementSelected || isEmpty) && hasBackgroundImage && showPrintAreaLines && !hasSpreadMask;
}

export default shouldShowPrintAreaLines;
